module.exports = __webpack_public_path__ + "static/media/menu_icon_white.cfa5bd5b.png";